//import { createBrowserHistory } from "history";
import { createHashHistory } from "history";
let history = null;
export default ()=>{
    if(!history){
        history = createHashHistory();
        //history = createBrowserHistory();
    }
    return history;
}